import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useMemo,
  useState,
} from "react";
import { StyledBookingsDetails } from "./styles";
import TabsV2 from "@/common/elements/TabsV2";
import ArrestInformationDetails from "./ArrestInformationDetails";
import BookingInformationDetails from "./BookingInformationDetails";
import HouseTrack from "../InmateDetails/HouseTrack";
import PersonalInformationDetails from "./PersonalInformationDetails";
import Select from "@/common/elements/InputElements/Select";
import BookingsCharges from "./BookingsCharges";
import InmateInformation from "./InmateInformation";
import JailIncidentsDetails from "./JailIncidentsDetails";
import BoookingsReleaseInformation from "./BoookingsReleaseInformation";
import BookingsComments from "./BookingsComments";
import OfficerReportsDetails from "./OfficerReportsDetails";
import AppointmentLogDetails from "./AppointmentLogDetails";
import MedicalAuthorizationsDetails from "./MedicalAuthorizationsDetails";
import BookingsMovementRules from "./BookingsMovementRules";
import FolderFlags from "../FolderFlags";
import Property from "../InmateDetails/Property";
import VisitorLogDetails from "./VisitorLogDetails";
import ClassificationDetails from "./Classification";
import AssociatesDetails from "./AssociatesDetails";
import InmateMedicationsDetails from "./InmateMedicationsDetails";
import BillingDetails from "./BillingDetails";
import VictimNotificationDetails from "./VictimNotificationDetails";
import BookingHolds from "./BookingHolds";
import BookingQueueDetails from "./BookingQueueDetails";
import SpinLoader from "@/common/elements/SpinLoader";
import BookingAdministrativeInformation from "./BookingAdministrativeInformation";
import ScheduledEventsDetails from "./ScheduledEventsDetails";
import ReleaseQueueDetails from "./ReleaseQueueDetails";
import ScheduledBookingInformation from "./ScheduledBookingInformation";
import Signatures from "./Signatures";
import Docs from "../InmateDetails/Docs";
import MedicalInfo from "../InmateDetails/MedicalInfo";
import { StyledFlex, StyledGridCol, StyledGridRow } from "@/common/styles";
import Button from "@/common/elements/Button";
import AdditionalBookingInformation from "./AdditionalBookingINfo";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import MedicalQuestionnaireList from "../InmateDetails/MedicalQuestionnaireList";
import CashAccountDetails from "@/components/cashAccountDetails/CashAccountDetails";
import { fetchAllSubmodules } from "@/apis/config/configApi";
import InmateHeader from "@/components/InmateHeader";
import { hasCheckSecurity, isNonEmptyVariable } from "@/util/common_function";
import {
  Entity_types,
  Permissions,
  Security_Types,
} from "@/util/permission_bits";
import { LABELS_CAPITAL } from "@/util/usePermissionMask";
import useDialog from "@/hooks/useDialog";
import {
  MODULES_LIST,
  MODULES_LIST_WITH_ID,
  SUB_MODULES_LIST_WITH_ID,
} from "@/util/common_variable";
import NoAccess from "./NoAccess";
import { setBookings, setBookingsFieldsEnabled } from "@/slices/bookingsSlice";
import HouseAndTracksForm from "../HouseandTracking/HouseAndTrackingForm";
import dayjs from "dayjs";
import _ from "lodash";
import { INMATE_DETAILS_MODE } from "../InmateDetails";

const BookingsDetails = forwardRef(
  ({
    currentModule,
    onNextClickTrigger,
    allFormRef,
    nextBtnRef,
    tabChangeRef,
    releaseInmate,
    takeProperty,
    releaseAllProperty,
    handleReBook,
    fromBookingStep = false,
    fromFolderDetails = false,
    selectedGroup,
    setSelectedGroup,
    setCurrentTabKey,
    currentTabKey,
  }) => {
    const { bookings, bookingsFieldsEnabled, isScheduledBooking } = useSelector(
      (state) => state?.bookings,
    );
    const fullSearch = useSelector((state) => state.fullSearch);
    const [isReleaseAllProperty, setIsReleaseAllProperty] = useState(null);
    const { allSubModules } = useSelector((state) => state.config);
    const [localSubModules, setLocalSubModules] = useState([]);
    const [isInLoan, setIsInLoan] = useState(false);
    const [isHouseAndTrackVisible, setIsHouseAndTrackVisible] = useState(false);
    const sectionItems = useMemo(
      () => [
        {
          id: "1",
          label: "Personal Information",
          key: "personal-information",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Arrest_Report,
          ) ? (
            <PersonalInformationDetails
              allFormRef={allFormRef}
              startingPoint="Bookings"
            />
          ) : (
            <NoAccess subModuleName={"arrest report"} />
          ),
        },
        {
          id: "2",
          label: "Arrest Information",
          key: "arrest-information",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Arrest_Report,
          ) ? (
            <ArrestInformationDetails
              arrestbookFormRef={allFormRef?.arrestbookFormRef}
              startingPoint="Bookings"
            />
          ) : (
            <NoAccess subModuleName={"arrest report"} />
          ),
        },
        {
          id: "3",
          label: "Booking Information",
          key: "booking-information",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Arrest_Report,
          ) ? (
            <BookingInformationDetails
              bookingInfoFormRef={allFormRef?.bookingInfoFormRef}
              startingPoint="Bookings"
            />
          ) : (
            <NoAccess subModuleName={"arrest report"} />
          ),
        },
        {
          id: "4",
          label: "Scheduled Booking Information",
          key: "scheduled-booking-information",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Arrest_Report,
          ) ? (
            <ScheduledBookingInformation
              scheduledBookingRef={allFormRef?.scheduledBookingRef}
              startingPoint="Bookings"
            />
          ) : (
            <NoAccess subModuleName={"arrest report"} />
          ),
        },
        {
          id: "5",
          label: "Charges",
          key: "charges",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Arrest_Report,
          ) ? (
            <BookingsCharges
              bookingChargeRef={allFormRef?.bookingChargeRef}
              startingPoint="Bookings"
            />
          ) : (
            <NoAccess subModuleName={"arrest report"} />
          ),
        },
        {
          id: "6",
          label: "Inmate Information",
          key: "inmate-information",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Arrest_Report,
          ) ? (
            <InmateInformation
              inmateInfoRef={allFormRef?.inmateInfoRef}
              startingPoint="Bookings"
            />
          ) : (
            <NoAccess subModuleName={"arrest report"} />
          ),
        },
        {
          id: "7",
          label: "Scheduled Events",
          key: "scheduled-events",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Arrest_Report,
          ) ? (
            <ScheduledEventsDetails
              scheduledEventRef={allFormRef?.scheduledEventRef}
              startingPoint="Bookings"
            />
          ) : (
            <NoAccess subModuleName={"arrest report"} />
          ),
        },
        {
          id: "8",
          label: "Release Information",
          key: "release-information",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Arrest_Report,
          ) ? (
            <BoookingsReleaseInformation
              boookingsRelease={allFormRef?.boookingsRelease}
              startingPoint="Bookings"
            />
          ) : (
            <NoAccess subModuleName={"arrest report"} />
          ),
        },
        {
          id: "9",
          label: "Comments",
          key: "comments",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Arrest_Report,
          ) ? (
            <BookingsComments
              bookingsCommentsRef={allFormRef?.bookingsCommentsRef}
              startingPoint="Bookings"
            />
          ) : (
            <NoAccess subModuleName={"arrest report"} />
          ),
        },
        {
          label: "Folder Flags",
          key: "jacket-flags",
          id: "10",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Arrest_Report,
          ) ? (
            <FolderFlags
              folderFlagsRef={allFormRef?.folderFlagsRef}
              startingPoint="Bookings"
            />
          ) : (
            <NoAccess subModuleName={"arrest report"} />
          ),
        },
        {
          id: "11",
          label: "Classification",
          key: "classification",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Arrest_Report,
          ) ? (
            <ClassificationDetails
              classificationDetailsRef={allFormRef?.classificationDetailsRef}
              startingPoint="Bookings"
            />
          ) : (
            <NoAccess subModuleName={"arrest report"} />
          ),
          // disabled: true,
          // icon: <StopOutlined />,
        },
        {
          id: "12",
          label: "Movement Rules",
          key: "movement-rules",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Arrest_Report,
          ) ? (
            <BookingsMovementRules
              bookingsMovementRulesRef={allFormRef?.bookingsMovementRulesRef}
              startingPoint="Bookings"
            />
          ) : (
            <NoAccess subModuleName={"arrest report"} />
          ),
        },
        {
          id: "13",
          label: "Housing and Tracking",
          key: "housing-tracking",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Arrest_Report,
          ) ? (
            <HouseTrack
              houseFormRef={allFormRef?.houseFormRef}
              startingPoint="Bookings"
            />
          ) : (
            <NoAccess subModuleName={"arrest report"} />
          ),
          // children: <HousingAndTracking houseFormRef={allFormRef?.houseFormRef} />,
        },
        {
          id: "14",
          label: "Associates",
          key: "associates",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Arrest_Report,
          ) ? (
            <AssociatesDetails
              associatesDetailsRef={allFormRef?.associatesDetailsRef}
              startingPoint="Bookings"
            />
          ) : (
            <NoAccess subModuleName={"arrest report"} />
          ),
          // disabled: true,
          // icon: <StopOutlined />,
        },
        {
          id: "15",
          label: "Holds",
          key: "holds",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Arrest_Report,
          ) ? (
            <BookingHolds
              bookingHoldsRef={allFormRef?.bookingHoldsRef}
              startingPoint="Bookings"
            />
          ) : (
            <NoAccess subModuleName={"arrest report"} />
          ),
        },
        {
          id: "16",
          label: "Linked and Scanned Documents",
          key: "linked-scanned-documents",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Arrest_Report,
          ) ? (
            <Docs
              docsRef={allFormRef?.docsRef}
              startingPoint="Bookings"
              parentKey={MODULES_LIST.BOOKINGS}
            />
          ) : (
            <NoAccess subModuleName={"arrest report"} />
          ),
        },
        {
          id: "17",
          label: "Signatures",
          key: "signatures",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Arrest_Report,
          ) ? (
            <Signatures
              signaturesRef={allFormRef?.signaturesRef}
              startingPoint="Bookings"
            />
          ) : (
            <NoAccess subModuleName={"arrest report"} />
          ),
          // disabled: true,
          // icon: <StopOutlined />,
        },
        {
          id: "18",
          label: "Victim Notification",
          key: "victim-notification",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Arrest_Report,
          ) ? (
            <VictimNotificationDetails
              victimNotificationDetailsRef={
                allFormRef?.victimNotificationDetailsRef
              }
              startingPoint="Bookings"
            />
          ) : (
            <NoAccess subModuleName={"arrest report"} />
          ),
          // disabled: true,
          // icon: <StopOutlined />,
        },
        {
          id: "19",
          label: "Billing",
          key: "billing",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Arrest_Report,
          ) ? (
            <BillingDetails
              billingDetailsRef={allFormRef?.billingDetailsRef}
              startingPoint="Bookings"
            />
          ) : (
            <NoAccess subModuleName={"arrest report"} />
          ),
          // disabled: true,
          // icon: <StopOutlined />,
        },
        {
          id: "20",
          label: "Visitors",
          key: "visitors",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Arrest_Report,
          ) ? (
            <VisitorLogDetails
              visitorLogDetailsRef={allFormRef?.VisitorLogDetailsRef}
              startingPoint="Bookings"
            />
          ) : (
            <NoAccess subModuleName={"arrest report"} />
          ),
          // disabled: true,
          // icon: <StopOutlined />,
        },
        {
          id: "21",
          label: "Jail Incidents",
          key: "jail-incidents",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Arrest_Report,
          ) ? (
            <JailIncidentsDetails
              jailIncidentsDetailsRef={allFormRef?.jailIncidentsDetailsRef}
              startingPoint="Bookings"
            />
          ) : (
            <NoAccess subModuleName={"arrest report"} />
          ),
          // disabled: true,
          // icon: <StopOutlined />,
        },
        {
          id: "22",
          label: "Booking Queue",
          key: "booking-queue",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Arrest_Report,
          ) ? (
            <BookingQueueDetails
              bookingQueueDetailsRef={allFormRef?.bookingQueueDetailsRef}
              startingPoint="Bookings"
            />
          ) : (
            <NoAccess subModuleName={"arrest report"} />
          ),
        },
        {
          id: "23",
          label: "Release Queue",
          key: "release-queue",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Arrest_Report,
          ) ? (
            <ReleaseQueueDetails
              releaseQueueDetailsRef={allFormRef?.releaseQueueDetailsRef}
              startingPoint="Bookings"
            />
          ) : (
            <NoAccess subModuleName={"arrest report"} />
          ),
        },
        {
          id: "24",
          label: "Medical Questionnaires",
          key: "medical-questionnaires",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Inmate_Medical,
          ) ? (
            <MedicalQuestionnaireList
              medicalRef={allFormRef?.medicalRef}
              startingPoint="Bookings"
            />
          ) : (
            <NoAccess subModuleName={"medical"} />
          ),
          // disabled: true,
          // icon: <StopOutlined />,
        },
        {
          id: "25",
          label: "Inmate Medications",
          key: "inmate-medications",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Inmate_Medical,
          ) ? (
            <InmateMedicationsDetails
              inmateMedicationsDetailsRef={
                allFormRef?.inmateMedicationsDetailsRef
              }
              startingPoint="Bookings"
            />
          ) : (
            <NoAccess subModuleName={"medical"} />
          ),
        },
        {
          id: "26",
          label: "Medical Authorizations",
          key: "medical-authorizations",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Inmate_Medical,
          ) ? (
            <MedicalAuthorizationsDetails
              medicalAuthorizationsDetailsRef={
                allFormRef?.medicalAuthorizationsDetailsRef
              }
              startingPoint="Bookings"
            />
          ) : (
            <NoAccess subModuleName={"medical"} />
          ),
        },
        {
          id: "27",
          label: "Appointment Log",
          key: "appointment-log",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Inmate_Medical,
          ) ? (
            <AppointmentLogDetails
              appointmentLogDetailsRef={allFormRef?.appointmentLogDetailsRef}
              startingPoint="Bookings"
            />
          ) : (
            <NoAccess subModuleName={"property"} />
          ),
        },
        {
          id: "28",
          label: "Property Taken From Inmate",
          key: "property-taken-inmate",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Inmate_Property,
          ) ? (
            <Property
              propertyRef={allFormRef?.propertyRef}
              propertyShow={true}
              isReleaseAllProperty={isReleaseAllProperty}
              startingPoint="Bookings"
            />
          ) : (
            <NoAccess subModuleName={"property"} />
          ),
        },
        {
          id: "29",
          label: "Property List",
          key: "property-list",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Inmate_Property,
          ) ? (
            <Property
              propertyListRef={allFormRef?.propertyListRef}
              startingPoint="Bookings"
            />
          ) : (
            <NoAccess subModuleName={"property"} />
          ),
        },
        {
          id: "30",
          label: "Officer Reports",
          key: "officer-reports",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Inmate_Officer_Reports,
          ) ? (
            <OfficerReportsDetails
              OfficerReportsDetailsRef={allFormRef?.OfficerReportsDetailsRef}
              startingPoint="Bookings"
            />
          ) : (
            <NoAccess subModuleName={"officer report"} />
          ),

          // disabled: true,
          // icon: <StopOutlined />,
        },
        {
          id: "31",
          label: "Administrative Information",
          key: "administrative-information",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Arrest_Report,
          ) ? (
            <BookingAdministrativeInformation
              bookingAdministrativeInformationRef={
                allFormRef?.bookingAdministrativeInformationRef
              }
              startingPoint="Bookings"
            />
          ) : (
            <NoAccess subModuleName={"arrest report"} />
          ),
        },
        {
          id: "32",
          label: "Additional Booking Information",
          key: "additional-booking-information",
          children: hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID.Arrest_Report,
          ) ? (
            <AdditionalBookingInformation startingPoint="Bookings" />
          ) : (
            <NoAccess subModuleName={"arrest report"} />
          ),
        },
        {
          id: "33",
          label: "Cash Account",
          key: "cash-account",
          children: <CashAccountDetails startingPoint="Bookings" />,
        },
      ],
      [isReleaseAllProperty],
    );
    const { showDialog } = useDialog();
    const dispatch = useDispatch();
    const selectOptions = [
      { key: "arrest-report",
        value: "arrest-report", 
        label: "Arrest Report" ,
        text: "Arrest_Report",
      },
      {
        key: "inmate-medical",
        value: "inmate-medical",
        label: "Inmate Medical",
        text: "Inmate_Medical",
      },
      // {
      //   key: "inmate-cash-account",
      //   value: "inmate-cash-account",
      //   label: "Inmate Cash Account",
      // },
      {
        key: "inmate-property",
        value: "inmate-property",
        label: "Inmate Property",
        text: "Inmate_Property",
      },
      {
        key: "inmate-officer-reports",
        value: "inmate-officer-reports",
        label: "Inmate Officer Reports",
        text: "Inmate_Officer_Reports",
      },
    ];

    useEffect(() => {
      const filteredData = selectOptions?.filter(
        (op) =>
          allSubModules?.some(
            (sub) =>
              sub?.subModuleName === op.label &&
              sub?.enabled
          ) &&
          hasCheckSecurity(
            Security_Types.functionality,
            Entity_types.subModule,
            LABELS_CAPITAL.VIEW,
            MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
            SUB_MODULES_LIST_WITH_ID[op.text] // ✅ fixed
          )
      );

      if (filteredData?.length) {
        setLocalSubModules(filteredData);
      }
    }, [allSubModules]);

    // Group mappings
    const groupMappings = {
      "arrest-report": [
        "personal-information",
        "arrest-information",
        "booking-information",
        "scheduled-booking-information",
        "charges",
        "inmate-information",
        "scheduled-events",
        "release-information",
        "comments",
        "jacket-flags",
        "classification",
        "movement-rules",
        "housing-tracking",
        "associates",
        "holds",
        "linked-scanned-documents",
        "signatures",
        "victim-notification",
        "billing",
        "visitors",
        "jail-incidents",
        "booking-queue",
        "release-queue",
        "administrative-information",
        "additional-booking-information",
      ],

      "inmate-medical": [
        "personal-information",
        "jacket-flags",
        "medical-questionnaires",
        "inmate-medications",
        "medical-authorizations",
        "appointment-log",
        "jail-incidents",
        "booking-queue",
        "release-queue",
        "administrative-information",
      ],

      "inmate-cash-account": [
        "personal-information",
        "cash-account",
        "jail-incidents",
        "booking-queue",
        "release-queue",
        "administrative-information",
      ],

      "inmate-property": [
        "personal-information",
        "signatures",
        "property-taken-inmate",
        "property-list",
        "jail-incidents",
        "booking-queue",
        "release-queue",
        "administrative-information",
      ],

      "inmate-officer-reports": [
        "personal-information",
        "officer-reports",
        "jail-incidents",
        "booking-queue",
        "release-queue",
        "administrative-information",
      ],
    };
    useEffect(() => {
      if (fromBookingStep) {
        dispatch(setBookingsFieldsEnabled(true));
      } else if (bookings?.bookingId) {
        dispatch(setBookingsFieldsEnabled(false));
      }
    }, []);
    // State Variables
    const [isLoading, setIsLoading] = useState(false);
    const [tabsToDisplay, setTabsToDisplay] = useState([]);
    const [isReturn, setIsReturn] = useState(false);
    const [lastLoan, setLastLoan] = useState(null);
    const [lastCell, setLastCell] = useState(null);
    const [selectedRow, setSelectedRow] = useState();
    const [houseTrackCounter, setHouseTrackCounter] = useState(0);
    const [selectedIndex, setSelectedIndex] = useState();

    useEffect(() => {
      setSelectedIndex(selectedRow?.inmateTrackingID);
    }, [selectedRow]);

    // Handle Select Change
    const handleSelectChange = (value) => {
      setSelectedGroup(value);
      setTabsToDisplay(groupMappings[value] || []);
    };

    // Filter and Sort Tabs to Display
    const sectionTabItems = sectionItems
      .filter((tab) => {
        return tab?.key && tabsToDisplay?.includes(tab.key);
      })
      .sort((a, b) => {
        const indexA = tabsToDisplay?.indexOf(a.key) ?? -1;
        const indexB = tabsToDisplay?.indexOf(b.key) ?? -1;
        return indexA - indexB;
      });

    // Tab Change Handler
    const onTabChange = (value) => {
      setCurrentTabKey(value);
    };

    // Set Initial State Based on `currentModule`
    useEffect(() => {
      setIsLoading(true);
      if (currentModule && groupMappings[currentModule]) {
        setSelectedGroup(currentModule);

        setTabsToDisplay(groupMappings[currentModule]);
        setCurrentTabKey(groupMappings[currentModule][0] || null);
        setIsLoading(false);
      }
    }, [currentModule]);

    // Update Tabs When `selectedGroup` Changes
    useEffect(() => {
      setIsLoading(true);
      if (selectedGroup && groupMappings[selectedGroup]) {
        setTabsToDisplay(groupMappings[selectedGroup]);
        setCurrentTabKey(groupMappings[selectedGroup][0] || null);
        setIsLoading(false);
      }
    }, [selectedGroup]);

    const handleMoveInmate = () => {
      setCurrentTabKey("housing-tracking");
    };

    useEffect(() => {
      setCurrentTabKey("property-taken-inmate");
    }, [isReleaseAllProperty]);

    useEffect(() => {
      let isLoan = bookings?.arrestReports?.[0]?.currentLocation;
      const latestLoanInmateTrack = bookings?.inmateTracking?.findLast(
        (track) => track?.inmateLocation === "Loan",
      );

      if (
        isNonEmptyVariable(isLoan) &&
        isNonEmptyVariable(latestLoanInmateTrack)
      ) {
        if (
          ["Loan", "At Court"].some((v) => isLoan?.includes(v)) &&
          latestLoanInmateTrack?.movementStatus === "Complete"
        ) {
          setIsInLoan(true);
        } else {
          setIsInLoan(false);
        }
      } else {
        setIsInLoan(false);
      }
    }, [bookings]);

    useEffect(() => {
      let tracking = _.clone(bookings?.inmateTracking);
      if (isNonEmptyVariable(tracking)) {
        tracking.reverse();
        let loan = null;
        let cell = null;
        tracking.forEach((e, i) => {
          if (
            loan == null &&
            e.inmateLocation == "Loan" &&
            e.movementStatus == "Complete"
          ) {
            loan = e;
          }
          if (
            cell == null &&
            e.inmateLocation == "In Jail" &&
            e.movementStatus == "Complete"
          ) {
            cell = e;
          }
        });
        if (isNonEmptyVariable(loan)) {
          setLastLoan(loan);
        }
        if (isNonEmptyVariable(cell)) {
          setLastCell(cell);
        }
      }
    }, [bookings]);

    const inmateReturnAction = () => {
      setIsHouseAndTrackVisible(true);
      setIsReturn(true);
    };

    const handleSetIsReleaseAllProperty = () => {
      setIsReleaseAllProperty(true);
    };

    function handleSetSelectedGroup(group) {
      let curr = localSubModules.find((mod) => mod?.key == group);
      if (curr) {
        setSelectedGroup(group);
      } else {
        setSelectedGroup(null);
        if (!window.isDialogShown) {
          window.isDialogShown = true;

          showDialog("info", {
            title: "Warning",
            content: `${group} is disabled, enable it in config and try again.`,
            confirmButtonText: "Ok",
          });

          setTimeout(() => {
            window.isDialogShown = false;
          }, 1000);
        }
        return;
      }
    }
    useImperativeHandle(tabChangeRef, () => ({
      onTabChange: onTabChange,
      setSelectedGroup: handleSetSelectedGroup,
      setIsReleaseAllProperty: handleSetIsReleaseAllProperty,
    }));

    const allItemsDisposed =
      bookings?.inmateProperty?.[0]?.inmatePropertyItems?.every(
        (item) =>
          item.inventoryItems &&
          item.inventoryItems[0] &&
          item.inventoryItems[0].itemStatus === "Disposed",
      );

    const getRestrictForMoveReason = (content) => {
      return new Promise((resolve, reject) => {
        showDialog("confirm", {
          title: "Warning",
          content: content,
          onConfirm: () => {
            resolve(true);
          },
          onCancel: () => {
            resolve(false);
          },
        });
      });
    };

    const handleSaveHouseTrack = () => {
      allFormRef?.houseFormRef.current
        .validateFields()
        .then(async () => {
          const values = allFormRef?.houseFormRef.current.getFormValues();

          const isTransportAdded =
            (values.inmateLocation === "Perm Housing Change" ||
              values.inmateLocation === "Transport") &&
            values?.movementStatus === "Complete";

          if (!bookings?.jacketId && isTransportAdded) {
            showDialog("info", {
              title: "Warning",
              content:
                "You must save the Booking record at least once before you can Transport the inmate.",
              confirmButtonText: "Ok",
            });
            return;
          }

          if (values?.moveReason === "Receive Inmate") {
            const content = `You should only enter a Reason for Movement of "Recieve Inmate" if you are recieving the inmate as the result of a Transport from another facility Are you recieving the inmate from another facility?`;
            const isMovementReason = await getRestrictForMoveReason(content);

            if (!isMovementReason) {
              houseFormRef.current.setFormValue("moveReason", "");
              return;
            }
          }

          const data = {
            ...values,
            expectedBackDate: isNonEmptyVariable(values?.expectedBackDateTime)
              ? dayjs(values?.expectedBackDateTime)?.format("MM/DD/YYYY")
              : null,
            expectedBackTime: isNonEmptyVariable(values?.expectedBackDateTime)
              ? dayjs(values?.expectedBackDateTime)?.format("HH:mm")
              : null,
            returnDate: isNonEmptyVariable(values?.returnBackDateTime)
              ? dayjs(values?.returnBackDateTime)?.format("MM/DD/YYYY")
              : null,
            returnTime: isNonEmptyVariable(values?.returnBackDateTime)
              ? dayjs(values?.returnBackDateTime)?.format("HH:mm")
              : null,
            scheduledDate: isNonEmptyVariable(values?.scheduleDateTime)
              ? dayjs(values?.scheduleDateTime)?.format("MM/DD/YYYY")
              : null,
            scheduledTime: isNonEmptyVariable(values?.scheduleDateTime)
              ? dayjs(values?.scheduleDateTime)?.format("HH:mm")
              : null,
            actualDate: isNonEmptyVariable(values?.actualDateTime)
              ? dayjs(values?.actualDateTime)?.format("MM/DD/YYYY")
              : null,
            actualTime: isNonEmptyVariable(values?.actualDateTime)
              ? dayjs(values?.actualDateTime)?.format("HH:mm")
              : null,
          };

          if (!data?.enterBusiness) {
            data.businesses = null;
          }

          delete data?.returnBackDateTime;
          delete data?.expectedBackDateTime;
          delete data?.scheduleDateTime;
          delete data?.actualDateTime;

          // const detail = flagDetails[INMATE_FLAG_TYPE.IN_JAIL];

          const inmateTracking = bookings?.inmateTracking || [];

          const existingIndex = inmateTracking.findIndex(
            (item) => item.inmateTrackingID === selectedIndex
          );

          let updatedTracking;

          if (existingIndex !== -1) {
            // Update existing item
            updatedTracking = inmateTracking.map((item, index) =>
              index === existingIndex ? { ...item, ...data } : item
            );
          } else {
            // Add new item
            updatedTracking = [...inmateTracking, data];
          }

          dispatch(
            setBookings({
              inmateTracking: updatedTracking,
            })
          );
          setIsHouseAndTrackVisible(false);

          setHouseTrackCounter((prev) => prev + 1);
          if (houseTrackCounter === 0 && isInLoan) {
            setTimeout(() => {
              // setIsHouseAndTrackVisible(true);
              setIsReturn(false);
              setIsInLoan(false);
            }, 100);
          }

          if (houseTrackCounter >= 1) {
            setHouseTrackCounter(0);
            setIsReturn(false);
            setIsInLoan(false);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    };

    return (
      <>
        <StyledBookingsDetails>
          <div className="action-bar">
            <StyledGridRow gutter={9} justify="space-between">
              <StyledGridCol>
                <StyledFlex gap="10px">
                  {isInLoan == false ? (
                    <>
                      {bookings?.inJail === true &&
                        !fullSearch &&
                        selectedGroup !== "inmate-property" && (
                          <Button
                            color="white"
                            onClick={() => releaseInmate(localSubModules)}
                            disabled={!bookingsFieldsEnabled}
                          >
                            Release
                          </Button>
                        )}
                      {bookings?.inJail === false &&
                        !fullSearch &&
                        selectedGroup !== "inmate-property" && (
                          <Button
                            color="white"
                            onClick={handleReBook}
                            disabled={
                              !bookingsFieldsEnabled || !bookings?.bookingId
                            }
                          >
                            Rebook
                          </Button>
                        )}
                      {selectedGroup === "arrest-report" &&
                        !fullSearch &&
                        !isScheduledBooking && (
                          <Button
                            color="white"
                            onClick={() => setCurrentTabKey("housing-tracking")}
                            disabled={!bookingsFieldsEnabled}
                          >
                            Move Inmate
                          </Button>
                        )}
                      {selectedGroup === "inmate-property" && (
                        <Button
                          color="white"
                          onClick={takeProperty}
                          disabled={!bookingsFieldsEnabled}
                        >
                          Take Property
                        </Button>
                      )}
                      {selectedGroup === "inmate-property" &&
                        bookings?.inmateProperty?.[0]?.inmatePropertyItems
                          ?.length > 0 &&
                        !allItemsDisposed && (
                          <Button
                            color="white"
                            onClick={() => {
                              releaseAllProperty();
                              setIsReleaseAllProperty(true);
                            }}
                            disabled={!bookingsFieldsEnabled}
                          >
                            Release All Property
                          </Button>
                        )}
                    </>
                  ) : (
                    <Button
                      color="white"
                      onClick={inmateReturnAction}
                      disabled={!bookingsFieldsEnabled}
                    >
                      Inmate Return
                    </Button>
                  )}

                  {/* <Button color="white" onClick={handleMoveInmate}>
                  Move Inmate
                </Button> */}
                </StyledFlex>
              </StyledGridCol>

              <StyledGridCol>
                <Select
                  value={selectedGroup}
                  allowClear={false}
                  options={localSubModules}
                  onChange={handleSelectChange}
                  style={{ width: "190px" }}
                  loading={false}
                />
              </StyledGridCol>
            </StyledGridRow>
          </div>
          <InmateHeader fromFolderDetails={fromFolderDetails} />
          <HouseAndTracksForm
            showDetailsPopup={isHouseAndTrackVisible}
            setShowDetailsPopup={setIsHouseAndTrackVisible}
            bookingsFieldsEnabled={bookingsFieldsEnabled}
            houseFormRef={allFormRef?.houseFormRef}
            isEdit={true}
            mode={INMATE_DETAILS_MODE.EDIT}
            handleSave={handleSaveHouseTrack}
            isReturn={isReturn}
            setIsReturn={setIsReturn}
            lastCell={lastCell}
            lastLoan={lastLoan}
            setLastCell={setLastCell}
            setLastLoan={setLastLoan}
            isInLoan={isInLoan}
            selectedRow={selectedRow}
            setSelectedRow={setSelectedRow}
          />
          <SpinLoader spinning={isLoading} tip="loading">
            {/* Sections */}
            <TabsV2
              activeKey={currentTabKey}
              navButtonsColor="default"
              onChange={onTabChange}
              items={sectionTabItems}
              nextBtnRef={nextBtnRef}
              onNextClickTrigger={onNextClickTrigger}
            />
          </SpinLoader>
        </StyledBookingsDetails>
      </>
    );
  },
);

export default BookingsDetails;
